import { render, staticRenderFns } from "./add_category.vue?vue&type=template&id=a41ebe1c&scoped=true&"
import script from "./add_category.vue?vue&type=script&lang=js&"
export * from "./add_category.vue?vue&type=script&lang=js&"
import style0 from "./add_category.vue?vue&type=style&index=0&id=a41ebe1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41ebe1c",
  null
  
)

export default component.exports